const { CPaymentsCommissionsMap } = require('@sigmasms/commons')
const { upgradeArray } = require('../utils')

const PAYMENTS_STATUSES = upgradeArray([ 'init', 'completed', 'refundRequested', 'refunded', 'partialRefunded', 'error' ])
const PAYMENTS_METHODS = upgradeArray([ 'tinkoff', 'mandarin', 'stripe' ])
const PAYMENTS_METHODS_CREDENTIALS_FIELDS = {
  tinkoff: [ 'TerminalKey', 'Password', 'ekamToken' ],
  mandarin: [ 'merchantId', 'secret', 'ekamToken' ],
  stripe: [ 'apikey' ]
}

module.exports = {
  PAYMENTS_STATUSES,
  PAYMENTS_METHODS,
  PAYMENTS_METHODS_CREDENTIALS_FIELDS,
  PAYMENTS_COMMISSIONS: CPaymentsCommissionsMap
}
